import React, { useState } from "react";
import axios from "axios"; // Import Axios
import { Link, useNavigate } from "react-router-dom";
import "./authenticate.css";
import ParkingImage from "../assets/parking_image.jpg";

function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_API_URL}/admin/api/login`,
        {
          email,
          password,
        }
      );

      if (response.status === 200) {
        // Store token if needed
        localStorage.setItem("adminToken", response.data.token);
        navigate("/adminDashboard");
      }
    } catch (err) {
      setError(
        err.response?.data?.message || "Login failed. Please try again."
      );
    }
  };

  return (
    <div className="adminLogin container">
      <div className="loginArea d-flex flex-column flex-lg-row col-12">
        <div className="form w-100 w-lg-50 p-4">
          <div className="introText mb-4">
            <h1>Welcome back Admin!</h1>
            <p>Enter your details to see what's new.</p>
          </div>
          {error && <p className="text-danger">{error}</p>}
          <form onSubmit={handleLogin}>
            <div className="d-flex flex-column mb-3">
              <input
                type="email"
                placeholder="Your Email"
                className="form-control"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
            <div className="d-flex flex-column mb-3">
              <input
                type={showPassword ? "text" : "password"}
                placeholder="Your Password"
                className="form-control"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </div>
            <div className="d-flex align-items-center mb-3">
              <input
                type="checkbox"
                id="showPassword"
                checked={showPassword}
                onChange={togglePasswordVisibility}
                className="me-2"
              />
              <label htmlFor="showPassword">Show Password</label>
            </div>
            <div className="submit">
              <button type="submit" className="btn btn-primary w-100">
                Login
              </button>
            </div>
            <div className="registerNow mt-3 text-center">
              <p>
                Are you new? <Link to="/adminRegister">Register Now</Link>
              </p>
            </div>
          </form>
        </div>

        {/* Image Section */}
        <div className="introImage w-100 w-lg-50">
          <img src={ParkingImage} alt="Parking area" className="img-fluid" />
        </div>
      </div>
    </div>
  );
}

export default AdminLogin;
